import { z } from "@msuite/utils/lib/zod";
import { defineQuery } from "@rocicorp/zero";
import { zql } from "../zql";

/**
 * Staffing carries the crew's organisation, and is read by that organisation and by the one whose
 * plan the crew stands on — the two arms of its read policy. A partner reaches its own staffing
 * through the first arm on a board it cannot otherwise see.
 */
export const userAssignmentQueries = {
	userByPlanId: defineQuery(z.object({ planId: z.uuid(), userId: z.string() }), ({ args, ctx }) => {
		return zql.userAssignments
			.where("userId", "=", args.userId)
			.where("planId", "=", args.planId)
			.where(({ or, cmp, exists }) =>
				or(
					cmp("orgId", "=", ctx.orgId),
					exists("plan", (plan) => plan.where("orgId", "=", ctx.orgId)),
				),
			)
			.one();
	}),
	byId: defineQuery(
		z.object({
			id: z.uuid(),
		}),
		({ args, ctx }) => {
			return zql.userAssignments
				.where("id", "=", args.id)
				.where(({ or, cmp, exists }) =>
					or(
						cmp("orgId", "=", ctx.orgId),
						exists("plan", (plan) => plan.where("orgId", "=", ctx.orgId)),
					),
				)
				.one();
		},
	),
	byCrewId: defineQuery(
		z.object({
			crewId: z.uuid(),
		}),
		({ args, ctx }) => {
			return zql.userAssignments
				.where("crewId", "=", args.crewId)
				.where(({ or, cmp, exists }) =>
					or(
						cmp("orgId", "=", ctx.orgId),
						exists("plan", (plan) => plan.where("orgId", "=", ctx.orgId)),
					),
				)
				.orderBy("ranking", "asc");
		},
	),
};
